import makeStyles from '@mui/styles/makeStyles';
import { themeConstants } from './theme';

const drawerWidth = themeConstants.drawerWidth;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    // zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    height: "100vh",
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    position: "absolute",
    left: 0,
    right: 0,
    width: "100%",
    flexGrow: 1,
    height: '100vh',
    paddingLeft: '50px',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    // justifyContent: 'space-between',
    overflow: 'hidden',
    flexDirection: 'column',

  },
  loginPaper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    // justifyContent: 'space-between',
    flexDirection: 'column',
    background: '#e3f2fd',
    opacity: 0.85
  },
  chartHeight: {
    height: 500,
  },
  fixedHeight: {
    height: 350,
  },
  homeHeatmapHeight: {
    height: 289,
    // maxHeight: '30vh'
  },
  homeGraphHeight: {
    height: 197,
    // maxHeight: '25vh'
  },
  homeSmallHeight: {
    height: 123,
    // maxHeight: '15vh'
  },
  homeMap: {
    width: '100%',
    height: '312px', 
    // maxHeight: "40vh"
  },
  homeMapDiv: {
    height: '312px',
  },
  smallHeight: {
    height: 175,
    overflow: 'hidden'
  },
  paperSmallerHeight: {
    height: 140
  },
  paperPizzaHome: {
    height: '289px'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  avatar_image: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  dataHistFormControl: {
    margin: theme.spacing(1),
    minWidth: 180
  },
  icon: {
    margin: 5,
    padding: 2
  },
  circularProgress: {
    color: '#14143c'
  },  
}));

export default useStyles;